import React from 'react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';

const Section = ({ n, title, children }) => (
  <section className="mt-8">
    <h2 className="font-heading font-bold text-xl sm:text-2xl text-rozops-navy tracking-tight">
      {n}. {title}
    </h2>
    <div className="mt-3 text-rozops-text-muted text-[15px] leading-relaxed space-y-2">{children}</div>
  </section>
);

const Bullets = ({ items }) => (
  <ul className="mt-2 space-y-1.5">
    {items.map((it) => (
      <li key={it} className="flex items-start gap-2">
        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-rozops-blue flex-shrink-0" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export default function Refund() {
  return (
    <div className="bg-rozops-bg min-h-screen">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="refund-page">
        <div className="inline-flex items-center gap-1.5 rounded-full bg-rozops-blue-light text-rozops-blue text-xs font-semibold px-3 py-1">Legal</div>
        <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rozops-navy tracking-tight">Refund Policy</h1>
        <p className="mt-2 text-sm text-rozops-text-muted">Effective Date: 14th July, 2026.</p>

        <div className="mt-8 bg-white rounded-2xl border border-gray-100 shadow-soft p-6 sm:p-8">
          <p className="text-rozops-text-muted text-[15px] leading-relaxed">
            This Refund Policy explains how refunds are handled for RozOps subscriptions and services.
          </p>

          <Section n={1} title="Subscription Fees">
            <p>RozOps offers subscription-based software services. Subscription charges, billing cycles, and pricing plans are displayed at the time of purchase.</p>
          </Section>

          <Section n={2} title="Free Trial">
            <p>If RozOps provides a free trial, users are encouraged to evaluate the platform during the trial period before purchasing a paid subscription.</p>
          </Section>

          <Section n={3} title="Refund Eligibility">
            <p>Unless otherwise required by applicable law, subscription fees are generally non-refundable after payment has been successfully processed.</p>
            <p>Refund requests may be considered in exceptional circumstances, including:</p>
            <Bullets items={[
              'Duplicate payment',
              'Incorrect payment due to a technical error',
              'Billing error caused by RozOps',
              'Payment processed after confirmed account cancellation due to our error',
            ]} />
            <p>Approved refunds will be processed using the original payment method where feasible.</p>
          </Section>

          <Section n={4} title="Non-Refundable Situations">
            <p>Refunds will generally not be provided for:</p>
            <Bullets items={[
              'Partial use of the subscription',
              'Change of mind',
              'Failure to use the platform',
              'User training requirements',
              'Internet connectivity issues outside our control',
              'Failure to cancel before the next billing cycle',
            ]} />
          </Section>

          <Section n={5} title="Subscription Cancellation">
            <p>Users may cancel future renewals according to the cancellation options available in their account.</p>
            <p>Cancellation prevents future recurring charges but does not automatically entitle the user to a refund for the current billing period.</p>
          </Section>

          <Section n={6} title="Refund Processing Time">
            <p>Approved refunds are generally processed within 7–14 business days, depending on the payment provider and banking system.</p>
          </Section>

          <Section n={7} title="Contact for Billing Issues">
            <p>For any billing or refund-related questions, please contact:</p>
            <div className="mt-2 grid gap-1.5 text-[15px]">
              <div><span className="font-semibold text-rozops-text">Brand:</span> RozOps</div>
              <div><span className="font-semibold text-rozops-text">Company:</span> Nexwis Innovations Private Limited</div>
              <div><span className="font-semibold text-rozops-text">Contact Person:</span> Kranthi Kumar K</div>
              <div><span className="font-semibold text-rozops-text">Mobile:</span> <a href="tel:+917672002525" className="text-rozops-blue">+91 7672002525</a></div>
              <div><span className="font-semibold text-rozops-text">Email:</span> <a href="mailto:hello@rozops.com" className="text-rozops-blue">hello@rozops.com</a></div>
              <div className="mt-3">
                <span className="font-semibold text-rozops-text">Registered Address:</span>
                <div className="text-rozops-text-muted mt-1 leading-relaxed">
                  Nexwis Innovations Private Limited<br />
                  T-HUB FOUNDATION, SY NO. 83/1,<br />
                  Raidurg, Hyderabad, Telangana, India – 500081
                </div>
              </div>
            </div>
          </Section>
        </div>
      </article>
      <Footer />
    </div>
  );
}
